import { gql } from '@apollo/client';

export const MA_DEALS_QUERY = gql`
  query maDeals(
    $filters: MaFilters
    $dealPriceFlowingBarrel: Boolean!
    $dealReservesAcquisitionCost: Boolean!
    $dealConsiderationByReserves: Boolean!
    $dealConsiderationByProduction: Boolean!
  ) {
    maDeals(filters: $filters) {
      deals {
        effectiveDate
        dealPriceFlowingBarrel @include(if: $dealPriceFlowingBarrel)
        dealReservesAcquisitionCost @include(if: $dealReservesAcquisitionCost)
        dealConsiderationByReserves @include(if: $dealConsiderationByReserves)
        dealConsiderationByProduction @include(if: $dealConsiderationByProduction)

        maCompanyTransactions {
          buyerCompany {
            name
          }

          sellerCompany {
            name
          }

          soldCompany {
            name
          }

          maAssetTransactions {
            assetName
          }
        }
      }
    }
  }
`;
